// components/sections/About.tsx
import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold">About Me</h1>
      <p>About page content...</p>
    </div>
  );
};

export default About;
